<template>
    <div class="thank-you-container">
        <div class="titulo">¡Gracias por tu reserva!</div>
        <div class="card appointment-card">
            <div class="left">
                Cita reservada
            </div>
            <div class="right">
                <p>
                    <strong>Cita:</strong>
                    {{ treatmentName }}
                </p>
                <p>
                    <strong>Fecha y Hora:</strong>
                    {{ formattedDate }} - {{ appointmentTime }}h
                </p>
                <p>
                    <strong>Dirección:</strong>
                    {{ clinicName }}
                </p>
                <p>
                    <strong>Nombre:</strong>
                    {{ $store.state.userInfo.name }}
                </p>
                <p>
                    <strong>Email:</strong>
                    {{ $store.state.userInfo.email }}
                </p>
                <p>
                    <strong>Teléfono:</strong>
                    {{ $store.state.userInfo.phone }}
                </p>
            </div>
        </div>
        <p>Hemos recibido tu solicitud con éxito. <strong>Te estaremos esperando el {{ formattedDate }} a las {{ appointmentTime }}h</strong> en nuestra clínica.</p>
        <p>En breve <strong>recibirás un correo electrónico</strong> con todos los detalles de tu reserva.</p>
        <p>Si tienes alguna pregunta o necesitas hacer algún cambio en tu reserva, no dudes en contactarnos.</p>
        <p style="
    font-size: 1.2rem;
    text-align: center;
    margin-top: 2rem;
">¡Estamos deseando verte pronto en nuestra clínica!</p>
    </div>
</template>

<script>
export default {
    name: "ThankYou",
    computed: {
        clinicName() {
            const clinics = {
                2: "Calle de Caleruega, 102 - Madrid",
                3: "Calle de Velázquez, 58 - Madrid",
            };
            return clinics[this.$store.state.clinic] || "Centro no seleccionado";
        },
        treatmentName() {
            const treatments = {
                implantes: "1ª - visita implantes / encías",
                ortodoncia: "1ª - visita ortodoncia",
                estetica: "1ª - visita estética",
                conservadora: "1ª - visita general",
            };
            return treatments[this.$store.state.treatment] || "Tratamiento no seleccionado";
        },
        appointmentDate() {
            return this.$store.state.cita.fecha || "Fecha no seleccionada";
        },
        appointmentTime() {
            return this.$store.state.cita.fIniAux || "Hora no seleccionada";
        },
        formattedDate() {
            return this.formatDate(this.appointmentDate);
        },
    },
    methods: {
        formatDate(date) {
            if (!date) return "Fecha no seleccionada";
            const [year, month, day] = date.split("/");
            return `${day}/${month}/${year}`;
        },
        pushToDataLayer() {
            window.dataLayer = window.dataLayer || [];
            console.log("data", window.dataLayer);
            window.dataLayer.push({
                event: "cita_online",
            });
            console.log("reserva online");
        },
    },
    mounted() {
        this.pushToDataLayer();
    },
};
</script>

<style scoped>
/* CSS original */
.thank-you-container {
    padding: 1rem;
}

.titulo {
    font-weight: bold;
    text-align: center;
    margin-bottom: 1rem;
    font-size: 1.4rem;
}

.thank-you-container p {
    color: var(--blue-color);
    font-size: 16px;
    margin-bottom: 0.5rem;
    line-height: normal;
}

.appointment-card {
    border-radius: 8px;
    margin: 0rem auto 2rem !important;
    font-size: 0.8rem;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}

.appointment-card .left {
    background-color: var(--blue-color);
    color: white;
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.1rem;
    border-radius: 8px 8px 0 0;
}

.appointment-card .right {
    padding: 10px;
}

.card {
    display: flex;
    border-radius: 8px;
    max-width: 500px;
    cursor: pointer;
    transition: box-shadow 0.3s;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    position: relative;
}

.card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}
</style>
